import { AdminActivityWebService } from '@linktivity/gds-neo';
import config from '../config';

const adminActivityApi = new AdminActivityWebService.ActivityApi(config);

export default adminActivityApi;
